// Generated from App.tsx for a single page build. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import SolutionsPage from "../pages/Solutions/Solutions";
const __wvcRoutePaths = ["/SolutionsPage", "/solutions"];
function AppRoutes() {
  const location = useLocation();
  return <Routes key={location.pathname}>
            
            
            
            <Route path={__wvcRoutePaths[0]} element={<SolutionsPage />} />
            <Route path={__wvcRoutePaths[1]} element={<SolutionsPage />} />
            
            </Routes>;
}
function App() {
  return <>
            <div className="app">
                <AppRoutes />
            </div>
        </>;
}
export default App;
